import React from 'react';
import { ApolloLink, ApolloClient, ApolloProvider, InMemoryCache, } from '@apollo/client';
import { AUTH_TYPE, createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
const NotificationHubProvider = ({ notificationHub, children }) => {
    if (!notificationHub)
        return React.createElement(React.Fragment, null, children);
    const { graphqlEndpointUrl: url, graphqlRegion: region, graphqlToken: token, } = notificationHub;
    if (!token || !region || !url)
        return React.createElement(React.Fragment, null, children);
    const auth = {
        type: AUTH_TYPE.AWS_LAMBDA,
        token,
    };
    const link = ApolloLink.from([
        createAuthLink({
            url,
            region,
            auth,
        }),
        createSubscriptionHandshakeLink({
            url,
            region,
            auth,
        }),
    ]);
    const client = new ApolloClient({
        link,
        cache: new InMemoryCache(),
    });
    return React.createElement(ApolloProvider, { client: client }, children);
};
export default NotificationHubProvider;
